export default __webpack_public_path__ + "static/media/moo-oon.7e6a3b0a.jpeg";